module.exports = require("lodash/trim");